<template>
  <div>
    <div class="row">
      <div class="col text-left">
        <button class="btn btn-link" v-on:click="close">
          Back to Budget Templates
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h5 v-if="!editing" class="modal-title">
          New {{ budgetCategoryName }} Template
        </h5>
        <h5 v-if="editing" class="modal-title">
          Edit {{ budgetCategoryName }} Template
        </h5>
      </div>
    </div>
    <div class="row text-left">
      <div class="col">
        <form @submit.prevent="saveBudgetTemplate">
          <div class="form-group">
            <label for="question">Budget Description</label>
            <input
              type="text"
              class="form-control"
              id="question"
              placeholder="Budget Description"
              required
              v-model="question"
            />
          </div>
          <div class="form-group">
            <div class="row pr-2">
              <div class="col-auto">
                <button
                  v-if="!selectedRowType.description"
                  type="button"
                  class="btn btn-sm btn-primary"
                  v-on:click="chooseRowType"
                >
                  Select Row Type
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-sm btn-primary"
                  v-on:click="chooseRowType"
                >
                  Change Row Type
                </button>
              </div>
              <div class="col-auto">
                <label v-if="selectedRowType.description">
                  Row Type: {{ selectedRowType.description }}
                </label>
                <label v-else>
                  No Row Type Selected
                </label>
              </div>
            </div>
          </div>
          <div
            class="px-2 py-2"
            style="border: 0.1rem solid gray; border-radius: 4px;"
          >
            <div class="form-group">
              <label for="title"><small>Title</small></label>
              <input
                class="form-control"
                id="title"
                v-model="reorderedBudgetTable.t"
                placeholder="Leave blank for no title"
              />
            </div>
            <div class="form-group">
              <label for="subtitle"><small>Subtitle</small></label>
              <input
                class="form-control"
                id="subtitle"
                v-model="reorderedBudgetTable.s"
                placeholder="Leave blank for no subtitle"
              />
            </div>
            <table class="table">
              <tbody id="budgetTable">
                <tr
                  v-for="(row, rowindex) in budgetTable.r"
                  :key="rowindex"
                  v-bind:class="{ 'header-row': row.h == true }"
                >
                  <i
                    v-if="rowindex != 0"
                    class="pointer material-icons text-danger mt-3"
                    v-on:click="removeRow(row)"
                  >
                    clear
                  </i>
                  <i v-else class="material-icons" style="visibility: hidden;"
                    >clear</i
                  >
                  <td
                    v-for="(col, index) in row.c"
                    :key="index"
                    v-bind:colspan="col.cs ? col.cs : 1"
                  >
                    <div v-if="col.i == 'd'" class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input
                        class="form-control"
                        type="number"
                        v-model="col.v"
                      />
                    </div>
                    <div v-else>
                      <input
                        v-if="col.sum"
                        class="form-control"
                        disabled
                        v-bind:value="
                          $updateBudgetCol(
                            col,
                            row.c[index - 2].v * row.c[index - 1].v
                          )
                        "
                      />
                      <input
                        v-else-if="col.st"
                        class="form-control"
                        disabled
                        v-bind:value="
                          $updateBudgetCol(
                            col,
                            $getBudgetSectionTotal(
                              reorderedBudgetTable.r,
                              row.c[0].v
                            )
                          )
                        "
                      />
                      <input
                        v-else
                        class="form-control"
                        v-bind:type="$getBudgetColType(col.i)"
                        v-model="col.v"
                      />
                    </div>
                  </td>
                  <i
                    v-if="row.h != true"
                    class="pointer handle material-icons mt-3"
                    >reorder</i
                  >
                  <i v-else class="material-icons" style="visibility: hidden;"
                    >reorder</i
                  >
                </tr>
                <tr v-if="budgetTable.r.length > 0">
                  <i class="material-icons" style="visibility: hidden;"
                    >clear</i
                  >
                  <td>
                    <button
                      class="btn btn-link"
                      type="button"
                      v-on:click="addDataRow"
                    >
                      Add Row
                    </button>
                  </td>
                  <td>
                    <button
                      class="btn btn-link"
                      type="button"
                      v-on:click="addTotalRow"
                    >
                      Add Total Row
                    </button>
                  </td>
                  <td v-if="budgetTable.r[0].c.length > 2"></td>
                  <td v-if="budgetTable.r[0].c.length > 3"></td>
                  <i class="material-icons" style="visibility: hidden;"
                    >reorder</i
                  >
                </tr>
                <tr v-if="budgetTable.r.length > 0" class="header-row">
                  <i class="material-icons" style="visibility: hidden;"
                    >clear</i
                  >
                  <td v-bind:colspan="budgetTable.r[0].c.length - 1">Total</td>
                  <td>{{ $getBudgetTotal(budgetTable.r) }}</td>
                  <i class="material-icons" style="visibility: hidden;"
                    >reorder</i
                  >
                </tr>
              </tbody>
            </table>
          </div>
          <p class="text-secondary">
            {{ JSON.stringify(budgetTable).length }} / 8000 characters
          </p>

          <div class="row">
            <div class="col">
              <button
                type="button"
                class="btn btn-danger"
                v-on:click="$emit('archiveBudgetTemplate')"
              >
                Archive
              </button>
            </div>
            <div class="col-auto">
              <button type="submit" class="btn btn-primary">
                Save Budget Template
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <SelectRowTypeModal @selectedRowType="rowTypeSelected" />
  </div>
</template>

<script>
import $ from "jquery";
import SelectRowTypeModal from "@/modals/ManageTemplates/SelectRowTypeModal";
import Sortable from "sortablejs";

export default {
  name: "EditBudgetTemplate",
  components: {
    SelectRowTypeModal
  },
  props: {
    Budget: Object,
    BudgetCategoryId: String,
    BudgetCategoryName: String
  },
  data() {
    return {
      question: "",
      editingBudget: null,
      editing: false,
      budgetCategoryId: this.BudgetCategoryId,
      budgetCategoryName: this.BudgetCategoryName,
      budgetTable: {
        t: "",
        s: "",
        r: []
      },
      reorderedBudgetTable: {
        t: "",
        s: "",
        r: []
      },
      selectedRowType: ""
    };
  },
  watch: {
    Budget: function() {}
  },
  mounted() {
    this.setSortable();
    if (this.Budget != null) {
      this.editingBudget = this.Budget;
      var table = this.Budget.Response;
      this.reorderedBudgetTable.t = table.t;
      this.reorderedBudgetTable.s = table.s;
      table.r.forEach(row => {
        this.budgetTable.r.push(row);
        this.reorderedBudgetTable.r.push(row);
      });
      this.question = this.Budget.Question;
      this.editing = true;
    } else {
      this.editing = false;
    }
  },
  methods: {
    async updateRowOrder(oldIndex, newIndex) {
      var movedRow = this.reorderedBudgetTable.r[oldIndex];
      if (oldIndex - newIndex > 0) {
        for (let index = oldIndex; index > newIndex; index--) {
          this.reorderedBudgetTable.r[index] = this.reorderedBudgetTable.r[
            index - 1
          ];
        }
      } else {
        for (let index = oldIndex; index < newIndex; index++) {
          this.reorderedBudgetTable.r[index] = this.reorderedBudgetTable.r[
            index + 1
          ];
        }
      }
      this.reorderedBudgetTable.r[newIndex] = movedRow;

      this.$forceUpdate();
    },
    setSortable() {
      var view = this;
      var el = document.getElementById("budgetTable");
      Sortable.create(el, {
        handle: ".handle",
        animation: 200,
        onEnd: function(e) {
          if (e.oldIndex != e.newIndex) {
            view.updateRowOrder(e.oldIndex, e.newIndex);
          }
        }
      });
    },
    close() {
      this.$emit("editClosed");
    },
    rowTypeSelected(rows, rowType) {
      this.budgetTable.r = [];
      this.reorderedBudgetTable.r = [];
      rows.forEach(row => {
        var newRow = JSON.parse(JSON.stringify(row));
        this.budgetTable.r.push(newRow);
        this.reorderedBudgetTable.r.push(newRow);
      });
      this.selectedRowType = rowType;
      $("#selectRowTypeModal").modal("hide");
    },
    chooseRowType() {
      $("#selectRowTypeModal").modal("show");
    },
    addDataRow() {
      var newCols = [];
      if (this.selectedRowType && this.selectedRowType != "") {
        newCols = JSON.parse(JSON.stringify(this.selectedRowType.value[1].c));
      } else {
        newCols = JSON.parse(JSON.stringify(this.reorderedBudgetTable.r[1].c));
      }
      var newRow = {
        c: newCols,
        h: false
      };
      this.budgetTable.r.push(newRow);
      this.reorderedBudgetTable.r.push(newRow);
    },
    addTotalRow() {
      var newRow = {
        c: [
          {
            v: "",
            cs: this.reorderedBudgetTable.r[1].c.length - 1
          },
          {
            v: 0,
            st: true
          }
        ],
        h: true,
        st: true
      };
      this.budgetTable.r.push(newRow);
      this.reorderedBudgetTable.r.push(newRow);
    },
    removeRow(row) {
      var budgetTableRowIndex = this.budgetTable.r.findIndex(r => r == row);
      this.budgetTable.r.splice(budgetTableRowIndex, 1);

      var reOrderedBudgetTableRowIndex = this.reorderedBudgetTable.r.findIndex(
        r => r == row
      );
      this.reorderedBudgetTable.r.splice(reOrderedBudgetTableRowIndex, 1);
    },
    async saveBudgetTemplate() {
      if (this.editing) {
        await this.editBudget();
      } else {
        await this.createBudget();
      }
    },
    async createBudget() {
      var view = this;
      view.$store.commit("updateLoading", true);
      var responseToCreate = {
        Question: view.$data.question,
        Response: JSON.stringify(view.reorderedBudgetTable),
        Application_Template_Response_Category_Id: view.$data.budgetCategoryId
      };
      await this.$createApplicationTemplateResponse(responseToCreate)
        .then(newResponse => {
          view.$emit("addedBudget", newResponse);
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    async editBudget() {
      var view = this;
      $("#budgetTemplateModal").modal("hide");
      view.$store.commit("updateLoading", true);
      var responseToUpdate = {
        Application_Template_Response_Id:
          view.$data.editingBudget.Application_Template_Response_Id,
        Question: view.$data.question,
        Response: JSON.stringify(view.reorderedBudgetTable),
        Application_Template_Response_Category_Id: view.$data.budgetCategoryId
      };
      await this.$updateApplicationTemplateResponse(responseToUpdate)
        .then(editedResponse => {
          view.$emit("editedBudget", editedResponse);
          view.$store.commit("updateLoading", false);
        })
        .catch(e => {
          console.log(e);
          $("#budgetTemplateModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      (this.question = ""),
        (this.editingBudget = null),
        (this.editing = false),
        (this.budgetTable = {
          t: "",
          s: "",
          r: []
        }),
        (this.reorderedBudgetTable = {
          t: "",
          s: "",
          r: []
        }),
        (this.selectedRowType = "");
    },
    addBlank() {
      this.response = this.response.concat("@__________@");
      $("#response").focus();
    }
  }
};
</script>

<style scoped>
tr {
  width: 100%;
}
</style>
